import _typeof from "@babel/runtime/helpers/typeof";
/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A server enforced rule that checks if the current user is allowed to perform all declared permissions on the resource
 * @export
 * @interface ResourceAuthorizationRule
 */

/**
 * Check if a given object implements the ResourceAuthorizationRule interface.
 */
export function instanceOfResourceAuthorizationRule(value) {
  return _typeof(value) === 'object' && value !== null && 'rid' in value && value['rid'] !== undefined && value['rid'] !== null && typeof value['rid'] === 'string' && 'permissions' in value && value['permissions'] !== undefined && value['permissions'] !== null && Array.isArray(value['permissions']) && value['permissions'].every(function (permission) {
    return typeof permission === 'string';
  });
}
export function ResourceAuthorizationRuleFromJSON(json) {
  return ResourceAuthorizationRuleFromJSONTyped(json, false);
}
export function ResourceAuthorizationRuleFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'rid': json['rid'] == null ? undefined : json['rid'],
    'permissions': json['permissions'] == null ? undefined : json['permissions']
  };
}
export function ResourceAuthorizationRuleToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'rid': value['rid'],
    'permissions': value['permissions']
  };
}